import { IAdaConfig } from '../../../layout/navigation/accessibility/MonsidoAdaScript';

export function getAdaConfig(): IAdaConfig {
	return {
		monsidoAdaToken: process.env.MONSIDO_ADA_TOKEN,
	};
}
